import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FileUploader } from "ng2-file-upload";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ConfigsService } from '../../providers/configs.service'
import { DocumentoService } from '../../services/documento.service'
import { AlertService } from '../../providers/alert.service'
import { ClienteService } from '../../services/cliente.service'

@Component({
	selector: 'app-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss', '../../assets/less/all.less']
})
export class FileUploadComponent implements OnInit {
	tipos;
	clientes;
	erros = [];
	uploadForm: FormGroup;
	loading = false;
	cor = 'primary';
	modo = 'indeterminate'

	public uploader: FileUploader = new FileUploader({
		isHTML5: true
	});
	title: string = 'Upload de Arquivos GSViewer';
	constructor(
		private fb: FormBuilder, 
		private http: HttpClient,
		public configs: ConfigsService,
		public documento_service: DocumentoService,
		public alerts: AlertService,
		public cliente_service: ClienteService,
	){ }

	getTipos() {
		this.documento_service.getListaTipos()
			.then(data => {
				this.tipos = data;


			})
			.catch(error => {
				this.alerts.openAlert("Ops,", 'Ocorreu um erro, verifique sua conexão com a internet e tente novamente')
				// this.loading = false;
			});
	}

	uploadSubmit() {
		let now = new Date
		let total_indo = this.uploader.queue.length
		let total_foi = 0
		console.log(this.uploader)
		for (let i = 0; i < this.uploader.queue.length; i++) {
			let fileItem = this.uploader.queue[i]._file;
			if (fileItem.size > 1000000000) {
				alert("Não é permitido envio de arquivos com mais de 100 MB.");
				return;
			}
		}
		console.log('fila upload', this.uploader)
		for (let j = 0; j < this.uploader.queue.length; j++) {
			this.loading = true
			this.uploader.queue[j].progress = 1

			let data = new FormData();
			let fileItem = this.uploader.queue[j]._file;
			console.log('op ', this.uploader.queue[j].onProgress(50));
			data.append('cod_documento', '1');
			data.append('num_documento', '');
			data.append('ano_doc', String(now.getFullYear()));
			data.append('titulo', fileItem.name);
			data.append('cliente', this.uploadForm.controls.cliente.value);
			data.append('documento', fileItem);
			data.append('tags', '');
			data.append('data_doc', String(now));
			data.append('classificacao', '1');
			data.append('empresa', '');
			data.append('extencao_doc', 'pdf');
			data.append('file_type', 'pdf');
			data.append('tamanho_doc', String(fileItem.size));
			data.append('file', fileItem);
			data.append('fileSeq', 'seq' + j);
			data.append('tipo_doc', this.uploadForm.controls.type.value);
			this.uploadFile(data)
				.subscribe(data => {
					// this.alerts.openAlert("Tudo certo,", fileItem.name + ' salvo com sucesso')
					total_foi = total_foi + 1
					// this.uploader.queue[j].onProgress(100);
					if(total_foi == total_indo){
						this.loading = false;
					}
				},
				error => {
					this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
					// this.uploader.queue[j].onProgress(0);
					this.erros.push(this.uploader.queue[j]._file)
					total_foi = total_foi + 1
					// this.uploader.queue[j].progress = 0
					// this.uploader.queue.splice(j,1)
					if(total_foi == total_indo){
						this.loading = false;
					}
				});
				
				
		}
		this.uploader.clearQueue();
		// this.alerts.openAlert("Resumo,", total_foi + ' arquivos enviados de um total de '+ total_indo)
		// this.loading = false
	}

	reenviaErros(){
		let now = new Date
		let total_indo = this.erros.length
		let total_foi = 0
		console.log('erroos',this.erros)
		for (let i = 0; i < this.erros.length; i++) {
			let fileItem = this.erros[i];
			if (fileItem.size > 1000000000) {
				alert("Não é permitido envio de arquivos com mais de 100 MB.");
				return;
			}
		}
		console.log('fila upload', this.erros)
		for (let j = 0; j < this.erros.length; j++) {
			this.loading = true
			let data = new FormData();
			let fileItem = this.erros[j];
			this.erros[j].progress = 50
			console.log(fileItem.name);
			data.append('cod_documento', '1');
			data.append('num_documento', '');
			data.append('ano_doc', String(now.getFullYear()));
			data.append('titulo', fileItem.name);
			data.append('cliente', this.uploadForm.controls.cliente.value);
			data.append('documento', fileItem);
			data.append('tags', '');
			data.append('data_doc', String(now));
			data.append('classificacao', '1');
			data.append('empresa', '');
			data.append('extencao_doc', 'pdf');
			data.append('file_type', 'pdf');
			data.append('tamanho_doc', String(fileItem.size));
			data.append('file', fileItem);
			data.append('fileSeq', 'seq' + j);
			data.append('tipo_doc', this.uploadForm.controls.type.value);
			this.uploadFile(data)
				.subscribe(data => {
					total_foi = total_foi + 1
					// this.erros[j].progress = 100
					if(total_foi == total_indo){
						this.loading = false;
					}
					this.erros.splice(j,1)
				},
				error => {
					this.alerts.openAlert("Ops,", 'Ocorreu um erro no documento' + fileItem.name);
					this.erros.push(fileItem)
					// this.erros[j].progress = 0
					console.log('error', this.erros[0])
					total_foi = total_foi + 1
					if(total_foi == total_indo){
						this.loading = false;
					}
				});
				
				
			}
			// this.alerts.openAlert("Resumo,", total_foi + ' arquivos enviados de um total de '+ total_indo)
			// this.erros = [];
			// this.loading = false
		}
		
		uploadFile(data: FormData): Observable<any> {
		// this.loading = true
		console.log('upload data', data)
		return this.http.post(this.configs.getEndpoint() + 'documentos', data);
	}

	getClientes(){
		this.cliente_service.getCliente('', '')
            .then(data => {
                if (data['items']) {
                    this.clientes = data['items'];
                    console.log(data);
                    // this.setPagination(data['_meta']['totalCount'], data['_meta']['currentPage'], data['_meta']['perPage']);
                    
                } else {
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, verifique sua conexão com a internet e tente novamente')
                }
            })
            .catch(error => {
				this.alerts.openAlert("Ops,", 'Ocorreu um erro, verifique sua conexão com a internet e tente novamente')
                // this.loading = false;
            });
	}

	ngOnInit() {
		this.getTipos()
		this.getClientes()
		this.uploadForm = this.fb.group({
			document: [null, null],
			cliente: [null, Validators.compose([Validators.nullValidator])],
			type: [null, Validators.compose([Validators.required])]
		});
	}

}
